<div class="font-13">2018 © <b>Conexia</b></div>
<div>
    <a class="px-3 pl-4" href="http://themeforest.net/item/adminca-responsive-bootstrap-4-3-angular-4-admin-dashboard-template/20912589" target="_blank">Link 1</a>
    <a class="px-3" href="http://admincast.com/adminca/documentation.html" target="_blank">Link 2</a>
</div>
